import { commonService } from './commonDashboardApiService';

function orderService() {
  function getOrdersPaged<IOrdersContainer>(id: string, pageSize: number, pageNumber: number) {
    return commonService.get<IOrdersContainer>('api/orderdonation/getorderspaged', {
      params: { ssouuid: id, pageSize: pageSize, pageNumber: pageNumber },
    });
  }

  function printOrders(id: string, orderNumber: string) {
    return `/api/orderdonation/print?ssouuid=${id}&orderNumber=${orderNumber}`;
  }

  return {
    getOrdersPaged,
    printOrders,
  };
}

export default orderService;
